export enum ActionTypes {
  MODAL_OPEN = 'experiments_takeover/MODAL_OPEN',
  MODAL_CLOSE = 'experiments_takeover/MODAL_CLOSE',
  DRAWER_OPEN = 'experiments_takeover/DRAWER_OPEN',
  DRAWER_OPEN_WITH_DATA = 'experiments_takeover/DRAWER_OPEN_WITH_DATA',
  DRAWER_CLOSE = 'experiments_takeover/DRAWER_CLOSE',
  SET_SOURCE = 'experiments_takeover/SOURCE',
  EXPERIMENT_DATA_LOADED = 'experiments_takeover/EXPERIMENT_DATA_LOADED',
  EXPERIMENT_DATA_ERRORED = 'experiments_takeover/EXPERIMENT_DATA_ERRORED',
  UPDATE_EXPERIMENT_LOCALE = 'experiments_takeover/UPDATE_EXPERIMENT_LOCALE',
  UPDATE_EXPERIMENT_VARIANTS = 'experiments_takeover/UPDATE_EXPERIMENT_VARIANTS',
  TOGGLE_SUBSET_TEST_SEND_VARIATION_SETTING = 'experiments_takeover/TOGGLE_SUBSET_TEST_SEND_VARIATION_SETTING',
}
